import * as React from 'react';

export interface IDtpStepReviewProps {
    onBackClick(): void;
    onAcceptClick(): void;
    onRejectClick(): void;
}

export const DtpStepReview = (props: IDtpStepReviewProps) => {
    return (
        <div className={'dtp-portal-card'}>
            <div className="title">
                <span>Step: Review logo file</span>
            </div>
            <div className="content">
                <p>
                    Review logo file and decide if it is possible to corrected. Than proceed to upload corrected logo or inform user that logo can not be corrected.
                </p>
            </div>
            <div className="actions">
                <button className="action-continue"
                    onClick={() => props.onBackClick()}>Back to download</button>
                <button className="action-fail"
                    onClick={() => props.onRejectClick()}>Not possible to correct</button>
                <button className="action-success"
                    onClick={() => props.onAcceptClick()}>Upload corrected logo</button>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-step-review.component.tsx